/* NIOL SPORTS — minimal theme JS */
(function () {
  'use strict';

  function initMobileNav() {
    var toggle = document.querySelector('[data-niol-nav-toggle]');
    var nav = document.getElementById('HeaderNav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('nav-open', open);
    });

    // Close on link click or Escape
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeNav();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    function closeNav() {
      nav.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
    }
  }

  function initSubmenus() {
    var toggles = document.querySelectorAll('[data-submenu-toggle]');
    Array.prototype.forEach.call(toggles, function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = btn.closest('.header__menu-item');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        var link = item.querySelector('.header__menu-link');
        if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initSubmenus();
  });
})();
